import HouseOfMathLoaderSkeleton from '~/shared/components/HouseOfMathLoaderSkeleton'

const CurriculumSkeleton = (): React.ReactElement => {
  return (
    <div className="w-full xl:max-w-168 mx-auto flex flex-col gap-y-10">
      <div className="flex justify-center h-60 md:h-78 w-full mx-auto bg-white/30 rounded border border-white">
        <HouseOfMathLoaderSkeleton className="h-full w-full rounded" />
      </div>
    </div>
  )
}

export default CurriculumSkeleton
